import { PaymentRequest, ServiceOrderType } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { Stack, StackItem, Tag } from '@optimus-web/core';
import { SpacedLongDash } from '@mews-commander/ui';
import { LocalizedCurrencyValue, LocalizedEnum, LocalizedText } from '@mews/framework';
import { getTagVariantFromPaymentRequestState, useCommanderSelector } from '@mews-commander/utils';
import { getServiceOrder } from '@mews-commander/legacy-entities/src/ducks';
import { NoActionBillListItem } from '../../../components';
import { ServiceName } from '../../../../../components';
import { PaymentRequestItemMenu } from './PaymentRequestItemMenu';

interface PaymentRequestItemProps {
    paymentRequest: PaymentRequest;
    billId: string;
    accountId: string;
    depth?: number;
}

const usePaymentRequestText = ({
    paymentRequest: { state: paymentRequestState, id, serviceOrderId, reason, amount, notes },
    billId,
    accountId,
}: PaymentRequestItemProps) => {
    const serviceOrder = useCommanderSelector((state) => getServiceOrder(state, { id: serviceOrderId || '' }));
    const reservation =
        serviceOrder?.data.discriminator === ServiceOrderType.Reservation ? serviceOrder.data.value : null;

    return (
        <Stack distribution="space-between">
            <Stack spacing="100" itemAlignment="center">
                <Tag variant={getTagVariantFromPaymentRequestState(paymentRequestState)}>
                    <LocalizedEnum prefix="PaymentRequestState" value={paymentRequestState} />
                </Tag>
                <StackItem>
                    <LocalizedText textKey={TextKey.PaymentRequest} />
                    {reason ? (
                        <>
                            {SpacedLongDash}
                            {reason}
                        </>
                    ) : null}
                    {notes ? (
                        <>
                            {SpacedLongDash}
                            {notes}
                        </>
                    ) : null}
                    {reservation ? (
                        <>
                            {SpacedLongDash}
                            <ServiceName id={reservation.serviceId} />
                            {reservation.number}
                        </>
                    ) : null}
                </StackItem>
            </Stack>
            <Stack itemAlignment="center" spacing="200">
                <LocalizedCurrencyValue value={{ value: amount?.value, currency: amount?.currencyCode }} />
                <PaymentRequestItemMenu paymentRequestId={id} billId={billId} accountId={accountId} />
            </Stack>
        </Stack>
    );
};

export const PaymentRequestItem = ({ paymentRequest, billId, accountId, depth }: PaymentRequestItemProps) => (
    <NoActionBillListItem primaryText={usePaymentRequestText({ paymentRequest, billId, accountId })} depth={depth} />
);
